import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import Login from "../pages/auth/login";
import ResetPassword from "../pages/auth/resetPassword";

import Dashboard from "../pages/dashboard/main-dashboard";
import DetailShift from "../pages/dashboard/past-shift-detail";
import Middleware from "../pages/Middleware";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Middleware />} />
      <Route path="/login*" element={<Login />} />
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/shift-detail" element={<DetailShift />} />
    </Routes>
  );
};

export default MainRoutes;
        